import agent from "src/api/agent";




export const addUser = (usr) => agent.requests.post(`/Admin/adduser`, usr);

export const updateUser = (usr) => agent.requests.post(`/Admin/updateuser`, usr);


export const listUser = (usr) => agent.requests.get(`/Admin/userlist`);
